import { Box, Button, Typography } from '@material-ui/core';
import React, { FC } from 'react';
import DateTimePicker from "react-datetime-picker";

interface Props {
    applyDateFilter: () => void;
    clearDateFilter: () => void;
    endDate: Date,
    startDate: Date,
    setEndDate: (value: Date) => void;
    setStartDate: (value: Date) => void;
}

const DateFilter: FC<Props> = ({applyDateFilter, clearDateFilter, endDate, startDate, setEndDate, setStartDate}) => {

    return (
        <div className="filter-date-dropdown">
            <Box display="" alignItems="center" justifyContent="flex-start" marginTop="1em">
                <Box paddingBottom="1em">
                <Typography gutterBottom className="base-color">
                    Start date
                 </Typography>
                </Box>
                <form >
                    <Box position="absolute">
                        <DateTimePicker
                            value={startDate}
                            format={"dd-MM-y h:mm:ss a"}
                            onChange={setStartDate}
                            // disableClock
                            // disableCalendar
                            maxDate={new Date("2051-01-18T19:55:00.000+00:00")}
                            minDate={new Date("2000-01-18T19:55:00.000+00:00")}
                        />
                        <Box marginTop="1em" >
                            {/* {!state.startDate && error.requiredStart && <div className="date-error">Required</div>} */}
                        </Box>
                    </Box>
                </form>
            </Box>

            <Box display="" alignItems="center" justifyContent="flex-start" marginTop="2em">
                <Box paddingBottom="1em">
                    <Typography gutterBottom className="base-color">
                        Finish date
                        </Typography>
                </Box>
                <form >
                    <Box position="absolute">

                        <DateTimePicker
                            value={endDate}
                            format={"dd-MM-y h:mm:ss a"}
                            onChange={setEndDate}
                            maxDate={new Date("2051-01-18T19:55:00.000+00:00")}
                            minDate={new Date("2000-01-18T19:55:00.000+00:00")}
                            // disableClock
                            // disableCalendar
                        />
                        {/* {error.endEarly && <div className=" date-error">Finish date cannot be earlier than Start date </div>}
                                        {error.endEarlyThanNow && <div className=" date-error"> Finish date cannot be earlier than now</div>} */}
                        <Box marginTop="1em" >
                            {/* {!state.endDate && error.requiredEnd && <div className="date-error">Required</div>} */}
                        </Box>
                    </Box>
                    <div className="filter-button-container">
                        <Box display="flex" justifyContent="space-evenly" alignItems="center" paddingTop="1em">
                            <Button id="apply-button" onClick={applyDateFilter}>Filter</Button>
                            <Button id="clear-button" onClick={clearDateFilter}>Clear</Button>
                        </Box>
                    </div>
                </form>
            </Box>
        </div>
    )
}

export default DateFilter